import React from 'react'

export const TemplateSanarContext = React.createContext({})
